import React from "react";

class ContentPagination extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  async componentDidMount() {}

  render() {
    return (
      <ul className="pagination justify-content-end">
        {this.props.currentPage !== 0 ? (
          <li className="page-item">
            <a
              className="page-link text-muted pointer"
              aria-label="Previous"
              href=""
              onClick={() => {
                this.props.onPageChange(this.props.currentPage - 1);
              }}
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
        ) : null}
        {Array.from(Array(this.props.totalPages), (e, index) => {
          let pageShow = this.props.pageShow;
          let isShown = false;

          if (this.props.currentPage < pageShow) {
            if (index < pageShow) isShown = true;
          } else if (
            this.props.currentPage >=
            this.props.totalPages - pageShow
          ) {
            if (index >= this.props.totalPages - pageShow) isShown = true;
          } else {
            let pageListNumber = Math.ceil(
              (this.props.currentPage + 1) / pageShow
            );
            if (pageListNumber === 0) pageListNumber = 1;

            let pageStart = (pageListNumber - 1) * pageShow;
            let pageEnd = pageListNumber * pageShow;

            if (index >= pageStart && index < pageEnd) isShown = true;
          }

          if (isShown) {
            return (
              <li
                className={
                  "page-item " +
                  (this.props.currentPage === index ? "active" : "")
                }
                key={index}
              >
                <a
                  className="page-link pointer"
                  onClick={() => {
                    this.props.onPageChange(index);
                  }}
                >
                  {index + 1}
                </a>
              </li>
            );
          }
        })}
        {this.props.currentPage !== this.props.totalPages - 1 ? (
          <li className="page-item">
            <a
              className="page-link text-muted pointer"
              aria-label="Next"
              onClick={() => {
                this.props.onPageChange(this.props.currentPage + 1);
              }}
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        ) : null}
      </ul>
    );
  }
}

export default ContentPagination;
